import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from './router';
import VueRouter from 'vue-router';
import VueTelInput from 'vue-tel-input';
import VueAnalytics from 'vue-analytics';
import './filters';
import {i18n} from './i18n'
import eventBus from './eventBus';
import ErrorList from './components/ErrorList';
import 'bootstrap/js/dist/dropdown';

// Clear errors on a new request
axios.interceptors.request.use((config) => {
    eventBus.$emit('clearErrors');

    return config;
});

axios.defaults.baseURL = process.env.VUE_APP_API;

axios.interceptors.request.use(config => {
    // Add header for POS token
    if (window.sessionStorage && window.sessionStorage.getItem('posToken')) {
        config.headers.common['POS-Token'] = window.sessionStorage.getItem('posToken');
    }

    // Add header for language
    config.headers.common['X-Language'] = i18n.locale;

    return config;
});

// Handle errors
axios.interceptors.response.use(null, error => {
    if (error.response) {
        // Skip 404 (Not Found)
        if (error.response.status === 404) {
            return Promise.reject(error);
        }

        // Handle 422 (Unprocessable Entity)
        if (error.response.status === 422) {
            // eslint-disable-next-line no-unused-vars
            for (let [field, errors] of Object.entries(error.response.data.errors)) {
                for (let error of errors) {
                    eventBus.$emit('error', error);
                }
            }

            return Promise.reject(error);
        }
    }

    // Others
    eventBus.$emit('error', error.message, true);

    return Promise.reject(error);
});

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueTelInput)

if (process.env.VUE_APP_GA_TRACKING_ID) {
    Vue.use(VueAnalytics, {
        id: process.env.VUE_APP_GA_TRACKING_ID,
        autoTracking: {
            exception: true
        },
        router
    });
}

Vue.component('ErrorList', ErrorList)

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
